import { render, staticRenderFns } from "./NuevoProducto.vue?vue&type=template&id=2ba842ec&scoped=true&"
import script from "./NuevoProducto.vue?vue&type=script&lang=js&"
export * from "./NuevoProducto.vue?vue&type=script&lang=js&"
import style0 from "./NuevoProducto.vue?vue&type=style&index=0&id=2ba842ec&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ba842ec",
  null
  
)

export default component.exports